export default "__VITE_ASSET__DQzpsRxu__"